import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TaskStatisItem } from '../../message.api.service';

/** statis 变更信号：type=load 表示全新加载/刷新（消费方需完整初始化），type=patch 表示局部未读扣减（消费方仅更新数据） */
type StatisChange = { taskId: number; type: 'load' | 'patch' };

/**
 * 任务 statis 共享数据源（左栏 task-message-item 生产，右栏 task-message-list 消费）
 *
 * 左栏展开任务拉取 statis 后写入；右栏不再自拉，改为按 taskId 读取同一份数据，
 * 从而消除「展开任务时左右两栏各拉一次 statis」的重复请求。
 * 由 message-panel 在 providers 局部提供，每次开面板独立实例，不残留旧任务缓存。
 */
@Injectable()
export class TaskStatisStore {
  private store = new Map<number, TaskStatisItem[]>();
  private readonly change$ = new BehaviorSubject<StatisChange | null>(null);

  /** 全新加载/刷新某任务 statis（左栏拉取后调用），触发消费方完整初始化 */
  load(taskId: number, list: TaskStatisItem[]) {
    this.store.set(taskId, list);
    this.change$.next({ taskId, type: 'load' });
  }

  /** 读取某任务的 statis；无则空数组 */
  get(taskId: number): TaskStatisItem[] {
    return this.store.get(taskId) ?? [];
  }

  /** 扣减某题未读数（幂等），仅局部更新不触发完整初始化 */
  patchUnread(taskId: number, threadId: number, clearedCount: number) {
    const list = this.store.get(taskId);
    if (!list) return;
    this.store.set(
      taskId,
      list.map(s => (s.id === threadId ? { ...s, unReadCount: Math.max(0, s.unReadCount - clearedCount) } : s))
    );
    this.change$.next({ taskId, type: 'patch' });
  }

  /** 订阅变更（发射被变更的任务 id 与类型） */
  changes() {
    return this.change$.asObservable();
  }
}
